import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const languageEntity: Entity = {
  model: model,
  repository: repository,
}

export default languageEntity
